// src/pages/RecommendationProjectPage/RisksTab/NDCTargetsCard.tsx
import React from "react";

interface Props {
  country: string;
}

export const NDCTargetsCard: React.FC<Props> = ({ country }) => {
  const ndcData = {
    "Sri Lanka": {
      targets: [
        "Forest cover increase to 32% by 2030",
        "4% reduction in GHG emissions by 2030",
        "30% of renewable energy in power generation by 2030",
      ],
    },
    India: {
      targets: [
        "Reduce emissions intensity by 45% by 2030",
        "50% renewable energy by 2030",
        "Create additional carbon sink of 2.5-3 billion tonnes through forest cover",
      ],
    },
  };

  const countryTargets = ndcData[country as keyof typeof ndcData]?.targets || [];

  return (
    <div className="mt-6 rounded-lg bg-white p-4 shadow-md">
      <h3 className="mb-4 text-lg font-medium">Country NDC Targets</h3>
      <div>
        <h4 className="font-medium">{country} NDC Targets</h4>
        <ul className="mt-2 list-disc pl-5">
          {countryTargets.map((target, index) => (
            <li key={index}>{target}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};
